import { connect } from 'react-redux';

import ServerMonitor from '../../components/sider/servermonitor';

export default connect()(ServerMonitor);



// WEBPACK FOOTER //
// ./containers/sider/servermonitor.js